import { Directive, HostListener, inject, input } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Use on `<a>` elements instead of `[routerLink]` when you want to:
 * - Always keep an `href` (right-click / middle-click / Ctrl+click open in new tab)
 * - Prevent Angular navigation when the current URL already starts with the target path
 */
@Directive({
  selector: 'a[sbNavigateIfInactive]',
  host: {
    '[attr.href]': 'sbNavigateIfInactive()',
  },
})
export class SbNavigateIfInactiveDirective {
  readonly sbNavigateIfInactive = input.required<string>();

  private readonly router = inject(Router);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    // Let modifier-key clicks and non-primary-button clicks fall through to the browser
    // so the user can open the link in a new tab naturally.
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const target = this.sbNavigateIfInactive();
    if (currentPath !== target && !currentPath.startsWith(target + '/')) {
      this.router.navigate([target]);
    }
  }
}
